import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_1: FaireProductEntity = {
  token: "nyc-acc-1",
  type: "product",
  name: "NYC Skyline Candle",
  brandName: "Manhattan Candle Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
  priceDollars: 22,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
  weight: 1.2,
  dimensions: {
    width: 3.5,
    height: 4,
    depth: 3.5,
  },
  description: "Hand-poured candle with NYC skyline design",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "handmade", "home-decor"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
